/* ============================================================
   BITSECURE — точка входа.
   Порядок важен: сначала подписываем рендер/форму на смену языка,
   затем applyLang() делает первую отрисовку, и только потом
   инициализируем наблюдатели появления и счётчики.
   ============================================================ */
import './style.css';
import { applyLang, getLang } from './i18n';
import { initRender } from './modules/render';
import { createForm } from './modules/form';
import { createPopover } from './modules/popover';
import { initNav } from './modules/nav';
import { initLangSwitch } from './modules/langSwitch';
import { initReveal } from './modules/reveal';
import { initCounters } from './modules/counters';

// 1. Подписки на смену языка (динамические блоки + форма).
initRender();
const form = createForm();

// 2. Интерактив.
createPopover(form);
initNav();
initLangSwitch();

// 3. Первая отрисовка под текущий язык (запускает подписчиков).
applyLang(getLang());

// 4. Наблюдатели появления (учтут уже отрисованные карточки) и счётчики.
initReveal();
initCounters();
